//header hover menu
document.querySelectorAll('header-menu details').forEach(details => {
  const summary = details.querySelector('summary');

  details.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });
});


// collection list js
function initFeaturedCollection(section = document) {

  section.querySelectorAll('#featured-collection-list').forEach(wrapper => {

    const buttons = wrapper.querySelectorAll('.collection__title_button');
    const productsWrapper = wrapper.querySelector('.ajax-products-wrapper');
    const viewAllLink = wrapper.querySelector('.collection_list_view-all a');

    if (!buttons.length || !productsWrapper || !viewAllLink) return;

    const loadCollection = (button) => {

      const ajaxUrl = button.dataset.collectionTitle;
      const limit = parseInt(button.dataset.collectionLimit) || 4;

      if (!ajaxUrl) return;

      // Active state
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Update View All link
      viewAllLink.href = ajaxUrl.split('?')[0];

      productsWrapper.classList.add('loading');
      productsWrapper.innerHTML = '';

      fetch(ajaxUrl)
        .then(res => res.text())
        .then(html => {
          const dom = new DOMParser().parseFromString(html, 'text/html');
          const products = dom.querySelectorAll('.grid__item');

          if (!products.length) {
            productsWrapper.innerHTML = `
              <div class="no-products-found">
                <p>No products found</p>
              </div>
            `;
            productsWrapper.classList.remove('loading');
            return;
          }

          products.forEach((product, index) => {
            if (index < limit) {
              productsWrapper.appendChild(product.cloneNode(true));
            }
          });

          productsWrapper.classList.remove('loading');
        })
        .catch(() => {
          productsWrapper.innerHTML = `
            <div class="no-products-found">
              <p>Something went wrong. Please try again.</p>
            </div>
          `;
          productsWrapper.classList.remove('loading');
        });
    };

    // Click events
    buttons.forEach(button => {
      button.addEventListener('click', () => loadCollection(button));
    });

    // Auto load first tab
    loadCollection(buttons[0]);

  });
}

/* Normal page load */
document.addEventListener('DOMContentLoaded', () => {
  initFeaturedCollection();
});

/* Shopify Theme Editor / AJAX section reload */
document.addEventListener('shopify:section:load', (event) => {
  initFeaturedCollection(event.target);
});


//variants slide js
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.offer-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 12,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
      },
      1024: {
        slidesPerView: 1.5,
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth > 989) return; // desktop skip

  document.querySelectorAll('.footer-block').forEach(block => {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    heading.addEventListener('click', () => {

      const isOpen = block.classList.contains('is-open');

      // close all (optional but recommended)
      document.querySelectorAll('.footer-block.is-open').forEach(openBlock => {
        openBlock.classList.remove('is-open');
        const openContent = openBlock.querySelector('.footer-block__details-content');
        if (openContent) openContent.style.height = '0px';
      });

      if (!isOpen) {
        block.classList.add('is-open');
        content.style.height = content.scrollHeight + 'px';
      }
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.size-variant-swiper').forEach((swiperEl) => {
    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      navigation: {
        nextEl: swiperEl.querySelector('.size-next'),
        prevEl: swiperEl.querySelector('.size-prev'),
      },
      breakpoints: {
        768: {
          spaceBetween:0
        }
      }
    });
  });
});


// shop by age sections

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shop-by-age .slider-container').forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 3000,           
        disableOnInteraction: false
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },

      breakpoints: {
        0: {
          slidesPerView: 2
        },
        769: {
          slidesPerView: 5
        }
      }
    });
  });
});
